import React from 'react';
import { Button } from 'antd';
import { observer } from 'mobx-react-lite';
import { useWrapUpTimer } from '@/hooks/useWrapUpTimer';
import { useStore } from '@/stores';
import { CloseOutlined } from '@ant-design/icons';
import { MessageIcon } from '@/components/MessageIcon/MessageIcon';
import timerIcon from '@/public/icons/timer.svg';
import './MinimizedWrapUpBar.scss';

interface MinimizedWrapUpBarProps {
  maximizeCallPage: () => void;
}

export const MinimizedWrapUpBar = observer(
  ({ maximizeCallPage }: MinimizedWrapUpBarProps) => {
    const { callStore } = useStore();
    const { removeWrapUp } = useWrapUpTimer();

    const parseTime = (time: number): string => {
      const minutes = Math.floor(time / 60);
      const seconds = time % 60;
      return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };

    const onRemoveWrapUp = (e: React.MouseEvent) => {
      e.stopPropagation();
      removeWrapUp();
    };

    return (
      <div className="minimized-wrap-up-bar" onClick={maximizeCallPage}>
        <div className="timer">
          <span className="timer-title">Wrap up time:</span>
          <span className="timer-text">
            <MessageIcon svgUrl={timerIcon} />{' '}
            {parseTime(callStore.wrapUpCounter ?? 0)}
          </span>
        </div>
        <Button
          onClick={onRemoveWrapUp}
          data-testid="remove-wrapup"
          danger
          type="primary"
          shape="circle"
          icon={<CloseOutlined />}
          size={'small'}
        ></Button>
      </div>
    );
  },
);
